export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export default {
  months,
  formatHolidayDatePicker: 'DD/MM/YYYY',
  formatFull: 'DD/MM/YYYY HH:mm:ss',
}